import { ReactNode } from "react";
import styles from "../public/HistoryEventView.module.scss";

export function HistoryEventViewFrame({
    actions,
    animated = false,
    date,
    description,
    image,
    title,
}: {
    actions?: ReactNode;
    animated?: boolean;
    date: ReactNode;
    description: ReactNode;
    image?: ReactNode;
    title: ReactNode;
}) {
    return (
        <div
            className={`${styles.event} ${animated ? styles.revealReady : styles.staticView}`}
            data-history-event-reveal={animated ? '' : undefined}
        >
            {animated && (
                <noscript>
                    <style>{".history-event-motion{animation:none!important;opacity:1!important;transform:none!important;will-change:auto!important}"}</style>
                </noscript>
            )}
            <div className={image ? styles.gridWithImage : styles.gridWithoutImage}>
                {image}

                <div className={image ? styles.contentWithImage : styles.contentWithoutImage}>
                    <div className={styles.contentInner}>
                        <div className={`${styles.yearMotion} history-event-motion`}>
                            {date}
                        </div>

                        <div className={`${styles.titleMotion} history-event-motion`}>
                            {title}
                        </div>

                        <div className={styles.scrollContent}>
                            <div className={`${styles.descriptionMotion} history-event-motion`}>
                                {description}
                            </div>

                            {actions && (
                                <div className={`${styles.linksMotion} history-event-motion`}>
                                    {actions}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function HistoryEventDateFrame({
    dateLabel,
    endYear,
    startYear,
}: {
    dateLabel: string;
    endYear?: string | null;
    startYear: string;
}) {
    return (
        <>
            <p className={styles.dateLabel}>{dateLabel}</p>
            <p className={styles.years}>
                <span>{startYear}</span>
                {endYear && (
                    <>
                        <span className={styles.yearSeparator}>-</span>
                        <span>{endYear}</span>
                    </>
                )}
            </p>
        </>
    );
}

export const historyEventFrameStyles = styles;
